<template lang="pug">
    v-container(fluid).pa-0
        sms-compliance-blocked-dialog(
          :value="showSmsComplianceBlockedDialog"
          @close="showSmsComplianceBlockedDialog = false"
        )
        v-layout(wrap)
            v-flex.center-elements
                v-btn(icon @click="$emit('openEventDrawer')").icon-container
                    v-icon.icon chat_bubble
                span.sub-icon Comment
            v-flex.center-elements
              v-tooltip(bottom :disabled="!emailIsUndeliverable" max-width="250px")
                span {{ emailBtnTooltip }}
                ld-gated-button.icon-container(
                    icon
                    slot="activator"
                    @click="$emit('send-bulk-emails')"
                    :feature="LdFeatures.Emails"
                    :disabled="emailIsUndeliverable"
                )
                    v-icon.icon(:class="{ 'email-warn': emailIsUndeliverable }") email
              span.sub-icon Email
            v-flex.center-elements(v-if="userHasTextFeature || gatedAction === gatedActions.ComplianceViolationBlocked")
                v-tooltip(bottom :disabled="!userHasTextFeature")
                  span {{ textOptinTooltip }}
                  v-btn.ld-gated-feature.icon-container(
                    v-if="gatedAction === gatedActions.ComplianceViolationBlocked"
                    slot="activator"
                    icon
                    @click="showSmsComplianceBlockedDialog = true"
                  )
                    div.icon-stack
                        div.material-icons.icon.stacked-icon(:style = "textOptinStyle") stay_current_portrait
                        div.material-icons.icon.stacked-icon.stacked(:style = "textOptinStyle") {{ textOptinIcon }}
                  ld-gated-button.icon-container(
                      v-else
                      icon
                      slot="activator"
                      @click="$emit('send-bulk-text')"
                      :feature="LdFeatures.TextMessaging"
                  )   
                    div.icon-stack
                        div.material-icons.icon.stacked-icon(:style = "textOptinStyle") stay_current_portrait
                        div.material-icons.icon.stacked-icon.stacked(:style = "textOptinStyle") {{ textOptinIcon }}
                span.sub-icon Text
            v-flex.center-elements(v-if="!isCallButtonDisabled")
                ld-gated-button.icon-container(
                    icon
                    slot="activator"
                    @click="$emit('call-contact')"
                )
                    v-icon.icon call
                span.sub-icon Call
            v-flex.center-elements
                ld-gated-button.icon-container(
                    icon
                    slot="activator"
                    @click="$emit('show-task-editor')"
                )
                    v-icon.icon event_note
                span.sub-icon Task
            v-flex.center-elements
                ld-gated-button.icon-container(
                    icon
                    slot="activator"
                    @click="$emit('start-Campaign')"
                    :feature="LdFeatures.Campaigns"
                )
                    v-icon.icon flight_takeoff
                span.sub-icon Campaign
            v-flex.center-elements
                v-menu(offset-y)
                    v-btn(icon slot="activator").icon-container
                        v-icon.icon more_vert

                    v-list.contact-actions
                        edit-hotness(
                            :contact-update-action-payload="contactUpdateActionPayload"
                            :selected-ids="selectedIds"
                            :hotnesses="hotnesses"
                            :patch-contacts="processBulkAction"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon whatshot
                                v-list-tile-content
                                    span Edit Hotness
                        edit-field(
                            :contact-update-action-payload="contactUpdateActionPayload"
                            :patch-contacts="processBulkAction"
                            title="Edit Source"
                            field-name="source"
                            field-text="name"
                            field-value="id"
                            :items="sources"
                            :selected-ids="selectedIds"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon play_for_work
                                v-list-tile-content
                                    span Edit Source
                        edit-field(
                            :contact-update-action-payload="contactUpdateActionPayload"
                            :patch-contacts="processBulkAction"
                            title="Edit Status"
                            field-name="status"
                            field-text="name"
                            field-value="id"
                            :items="statuses"
                            :selected-ids="selectedIds"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon create
                                v-list-tile-content
                                    span Edit Status
                        edit-contact-type(
                            :contact-update-action-payload="contactUpdateActionPayload"
                            :patch-contacts="processBulkAction"
                            :contact-types="contactTypes"
                            :selected-ids="selectedIds"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon subject
                                v-list-tile-content
                                    span Edit Contact Type
                        edit-assigned-user(
                            :team-members="teamMembers"
                            :selected-ids="selectedIds"
                            :current-contact="selectedContacts"
                            :patch-contacts="processBulkAction"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                            :contact-update-action-payload="contactUpdateActionPayload"
                            :selected-ids-with-assignee-id="selectedIdsWithAssigneeId"
                            :isContactProfile="true"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon supervisor_account
                                v-list-tile-content
                                    span Edit Assigned User
                        tags(
                            action="add"
                            :tags-list="tags"
                            :selected-ids="selectedIds"
                            :patch-contacts="processBulkAction"
                            :contact-update-action-payload="contactUpdateActionPayload"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="" data-cy="add-tags")
                                v-list-tile-action
                                    v-icon local_offer
                                v-list-tile-content
                                    span Add Tags
                        tags(
                            action="remove"
                            :tags-list="tags"
                            :selected-ids="selectedIds"
                            :patch-contacts="processBulkAction"
                            :contact-update-action-payload="contactUpdateActionPayload"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="" data-cy="remove-tags")
                                v-list-tile-action
                                    v-icon $vuetify.icons.tag-minus
                                v-list-tile-content
                                    span Remove Tags
                        tags(
                            action="replace"
                            :tags-list="tags"
                            :selected-ids="selectedIds"
                            :patch-contacts="processBulkAction"
                            :contact-update-action-payload="contactUpdateActionPayload"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="" data-cy="replace-tags")
                                v-list-tile-action
                                    v-icon $vuetify.icons.tag-right-arrow
                                v-list-tile-content
                                    span Replace Tags
                        tags(
                            action="delete"
                            :tags-list="tags"
                            :selected-ids="selectedIds"
                            :patch-contacts="processBulkAction"
                            :contact-update-action-payload="contactUpdateActionPayload"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="" data-cy="delete-tags")
                                v-list-tile-action
                                    v-icon $vuetify.icons.tag-remove
                                v-list-tile-content
                                    span Delete Tags
                        Add-contacts-to-static-list(
                            :selected-ids="selectedIds"
                            :patch-contacts="bulkPatchContacts"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon person_add
                                v-list-tile-content
                                    span Add to Static List
                        delete-contact-from-static-lists.contact-card-settings(
                            v-if="emailLists.length > 0"
                            :email-lists="emailLists"
                            @update-email-lists-state="$emit('update-email-lists-state')"
                        )
                            v-list-tile(
                                slot="activator"
                                @click=""
                            )
                                v-list-tile-action
                                    v-icon person_add_disabled
                                v-list-tile-content
                                    span Remove From Static List
                        create-zipform-transaction(
                            :add-events="bulkCreateEvents"
                            @contact-updated="refreshPage"
                        )
                            //- @click="" is necessary to show blue hover highlight
                            v-list-tile.py-2(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon.lonewolf-icon $vuetify.icons.lonewolf
                                v-list-tile-content
                                    span.transaction-lonewolf Start transactions in Lone Wolf
                                        br
                                        | Transactions (zipForm Edition)
                        cloud-cma(
                            :selected-ids="selectedIds"
                            @created-cloud-report="$emit('refresh-events')"
                        )
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon.cloudcma-icon(size="20") $vuetify.icons.cloud-cma
                                v-list-tile-content
                                    span Create a Cloud CMA
                        transaction-desk(
                            @created-transaction="$emit('refresh-events')"
                        )
                            v-list-tile.py-2(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon.lonewolf-icon $vuetify.icons.lonewolf
                                v-list-tile-content
                                    span.transaction-desk Start transactions in Lone Wolf
                                        br
                                        | Transactions (TransactionDesk Edition)
                        delete-contact(
                            :selected-ids="selectedIds"
                            :selected-contacts="selectedContacts"
                            :should-redirect="shouldRedirect"
                            :bulk-delete-contacts="processBulkAction"
                            @deselect-all="$emit('deselect-all')"
                            @contact-updated="refreshPage"
                        )
                            v-list-tile(slot="activator" @click="")
                                v-list-tile-action
                                    v-icon delete
                                v-list-tile-content
                                    span Delete Contact
                span.sub-icon More

</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { LdGatedButton, LdFeatures } from 'lion-vue';
import sendSMSGate from '@/Core/mixins/send-sms-gate';
import {
  STATUS,
  BUTTON_STYLE,
  BUTTON_ICON,
  BUTTON_TOOLTIP
} from '../../config/profile-optin-status';

const DeleteContact = () =>
    import(/* webpackChunkName: 'DeleteContact' */ '@/Contacts/components/actions/DeleteContact');
const EditField = () =>
    import(/* webpackChunkName: 'EditField' */ '@/Contacts/components/actions/EditFieldModal');
const DeleteContactFromStaticLists = () =>
    import(/* webpackChunkName: 'DeleteContactFromStaticLists' */ '@/Contacts/components/actions/DeleteContactFromStaticLists');
const AddContactsToStaticList = () =>
    import(/* webpackChunkName: 'AddContactsToStaticList' */ '@/Contacts/components/actions/AddContactsToStaticList');
const AddTag = () =>
    import(/* webpackChunkName: 'AddTag' */ '@/Contacts/components/actions/AddTagModal');
const EditContactType = () =>
    import(/* webpackChunkName: 'EditContactType' */ '@/Contacts/components/actions/EditContactType');
const EditAssignedUser = () =>
    import(/* webpackChunkName: 'EditAssignedUser' */ '@/Contacts/components/actions/EditAssignedUser');
const EditHotness = () =>
    import(/* webpackChunkName: 'EditHotness' */ '@/Contacts/components/actions/EditHotness');
const CreateZipformTransaction = () =>
    import(/* webpackChunkName: 'CreateZipformTransaction' */ '@/Contacts/components/actions/CreateZipformTransaction');
const CloudCma = () =>
    import(/* webpackChunkName: 'CloudCma' */ '@/Contacts/components/actions/CloudCma');
const TransactionDesk = () =>
    import(/* webpackChunkName: 'TransactionDesk' */ '@/Contacts/components/actions/TransactionDesk');
const RegisterBrandModal = () =>
    import(/* webpackChunkName: 'RegisterBrandModal' */ '@/Core/components/RegisterBrandModal');
const Tags = () => 
    import(/* webpackChunkName: 'Tags' */ '@/Contacts/components/actions/TagModal');
const SmsComplianceBlockedDialog = () =>
    import(/* webpackChunkName: 'SmsComplianceBlockedDialog' */ '@/Core/components/SmsComplianceBlockedDialog');

export default {
  name: 'BulkActionV2',
  components: {
    LdGatedButton,
    EditHotness,
    EditAssignedUser,
    EditContactType,
    AddTag,
    AddContactsToStaticList,
    DeleteContactFromStaticLists,
    EditField,
    DeleteContact,
    CreateZipformTransaction,
    CloudCma,
    TransactionDesk,
    RegisterBrandModal,
    Tags,
    SmsComplianceBlockedDialog,
  },
  mixins: [sendSMSGate],
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
    hotnesses: {
      type: Array,
      default: () => [],
    },
    selectedContacts: {
      type: Array,
      default: () => [],
    },
    teamMembers: {
      type: Array,
      default: () => [],
    },
    contactTypes: {
      type: Array,
      default: () => [],
    },
    shouldRedirect: {
      type: Boolean,
      default: false,
    },
    sources: {
      type: Array,
      default: () => [],
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    emailLists: {
      default: () => [],
    },
    tags: {
      type: Array,
      default: () => [],
    },
    bulkPatchContacts: {
      type: Function,
    },
    validateDescription: {
      type: Function,
    },
    bulkCreateEvents: {
      type: Function,
    },
    selectedIdsWithAssigneeId: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      LdFeatures,
      showRegisterBrandModal: false,
      showSmsComplianceBlockedDialog: false,
    };
  },
  async mounted() {
    if (!this.has10dlcRegister || this.isRegistration10dlcIncomplete) {
      this.checkFor10dlcRegister();
    }
    this.checkContactOptInStatus(this.selectedIds[0]);
  },
  methods: {
    ...mapActions('contactsTable/bulkActions', ['processBulkAction']),
    ...mapActions('conversations', ['checkFor10dlcRegister','checkContactOptInStatus']),
    contactUpdateActionPayload(payload) {
      return {
        type: "update",
        resource: "contacts",
        payload: payload,
      };
    },
    refreshPage() {
      this.$emit('contact-updated');
    },
  },
  watch: {
    selectedIds:  {
      handler(val) {
        this.checkContactOptInStatus(val[0]);
      }
    }
  },
  computed: {
    ...mapState({
        user: state => state.userInformation.user,
        has10dlcRegister: state => state.conversations.has10dlcRegister,
        isRegistration10dlcIncomplete: state => state.conversations.isRegistration10dlcIncomplete,
        optinStatus: state => state.conversations.contactOptInStatus,
        suppressions: state => state.emailSuppressions.suppressions,
    }),
    ...mapGetters('userInformation', ['userHasFeatureFlag']),
    textOptinStyle() {
      if (this.optinStatus === STATUS.approved) {
        return BUTTON_STYLE.approved;
      }
      if (this.optinStatus === STATUS.denied) {
        return BUTTON_STYLE.denied;
      }
      return BUTTON_STYLE.pending;
    },
    isCallButtonDisabled() {
      return this.user && 
              this.user.subscriptionOverview && 
              this.user.subscriptionOverview.txt_status === 'trial';
    },
    textOptinIcon() {
      if (this.optinStatus === STATUS.approved) return BUTTON_ICON.approved;
      if (this.optinStatus === STATUS.denied) return BUTTON_ICON.denied;
      return BUTTON_ICON.pending;
    },
    userHasTextFeature() {
      return this.user &&
        this.user.features &&
        this.user.features[LdFeatures.TextMessaging] &&
        this.user.features[LdFeatures.TextMessaging].has_access
    },
    textOptinTooltip() {
      if (this.optinStatus === STATUS.approved) return BUTTON_TOOLTIP.approved;
      if (this.optinStatus === STATUS.denied) return BUTTON_TOOLTIP.denied;
      return BUTTON_TOOLTIP.pending;
    },
    emailIsUndeliverable() {
      return this.suppressions && !!this.suppressions.length;
    },
    emailBtnTooltip() {
      return 'Emails to this address are undeliverable. Check the Email Status field below for more details.';
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-container .icon {
  text-align: center;
  border-radius: 30px;
  background-color: #dee8f2;
  color: var(--v-primary-base);
  height: 35px;
  width: 35px;
  font-size: 18px;
}

.icon.email-warn {
  background-color: var(--v-warning-base);
  color: white;
}

.sub-icon {
  color: var(--v-primary-base);
  font-size: 11px;
  font-weight: 300;
  letter-spacing: -0.07px;
  line-height: 15px;
}

.center-elements {
  text-align: center;
  width: 40px;
  line-height: 1;
}

.v-toolbar__content {
  height: 100% !important;
  padding: 0 !important;
}

.transaction-lonewolf{
  line-height: 1.2;
}

.lonewolf-icon {
  transform: scale(1.2);
}

.cloudcma-icon {
  color: #20b575;
  padding: 1px;
}
.icon-stack {
  display: flex;
  align-items: center;
  justify-content: center;
}

.stacked-icon {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
}

.stacked {
  background-color: transparent !important;
  font-size: 10px !important;
}
</style>
